import { Icons } from "@osttra/ds-react";
import "./LoginInformationSection.css";

const LoginInformationSection = () => {
  return (
    <aside className="osttraLoginInformationSection">
      <div className="informationContent">
        <Icons.InfoCircle color="info" size="large" />
        <p>
          OSTTRA has introduced a new Single Sign On solution that aims to streamline the process of accessing our suite
          of applications whilst delivering enhanced security.
        </p>
        <p>
          Until your organisation has been migrated, the method of authentication remains unchanged. Once your
          organisation has migrated, the new OSTTRA SSO service will be used.
        </p>
        <p>
          If you would like to understand more about OSTTRA SSO and how your organisation may benefit by signing up for
          migration, please contact -{" "}
          <a href="mailto:support@osttra.com">
            support@osttra.com
          </a>
        </p>
      </div>
    </aside>
  );
};
export default LoginInformationSection;
